/// <reference path="../../types.d.ts" />
import { cmxReducerFactory } from '../reducer-utils';
import * as CaseDocumentsActions from '../../actions/case-documents.actions';
import * as UIActions from '../../actions/ui';
import { setActiveProcess } from '../../actions/json-view';
import { decorateNotes } from '../cases.reducer';

export const InitialState = {
  activeCase: {} as CMxAPI.Case,
  activeCaseRun: {} as CMxAPI.CaseRun,
  documentMetadata: [] as CMxAPI.DocumentMetadata[],
  activeNotes: [],
  notes: [],
  loading: true,
  locked: false
};

function handleDefault(state: any) {
  return { ...state };
}

const reducer = cmxReducerFactory<CMx.CaseDocumentsState>(InitialState)
  .case(CaseDocumentsActions.loadDocuments.async.done, (state, { result }) => {
    return {
      ...state,
      loading: false
    };
  })
  .case(UIActions.parentDidNavigate, (state, didNavigate) => {
    return { ...state, locked: !didNavigate };
  })
  .cases(
    [
      CaseDocumentsActions.fetchDocument.async.started,
      UIActions.dismissFeedback
    ],
    state => {
      return {
        ...state,
        feedback: null
      };
    }
  )
  .case(CaseDocumentsActions.fetchDocument.async.failed, (state, { error }) => {
    return {
      ...state,
      feedback: {
        message: error.message,
        className: 'error',
        id: Math.round(Math.random() * 1000000),
        dismissable: true,
        meta: {
          level: 'ERROR'
        }
      }
    };
  })
  .case(CaseDocumentsActions.fetchDocument.async.done, (state, { result }) => {
    const { note: original, metadata } = result;

    const note = {} as CMxAPI.Note;
    note.content = original.Note;
    note.description = metadata.documentDescription;
    note.document_id = metadata.documentId;
    note.id = metadata.documentId;
    note.filename = metadata.documentName;
    note.filetype = metadata.mimeType;
    note.type = metadata.mimeType;
    const activeNotes = decorateNotes([note]);

    return {
      ...state,
      activeNotes
    };
  })
  .case(
    CaseDocumentsActions.docMetadataAvailable,
    (state, documentMetadata) => {
      return {
        ...state,
        documentMetadata
      };
    }
  )
  .case(
    CaseDocumentsActions.caseDetailAvailable,
    (state, caseDetailAndProcess) => {
      const { caseDetail, activeProcess } = caseDetailAndProcess;
      return {
        ...state,
        activeCase: caseDetail,
        activeCaseRun: activeProcess
      };
    }
  )
  .case(setActiveProcess, (state, newActiveCaseRun) => {
    return {
      ...state,
      activeCaseRun: newActiveCaseRun
    };
  })
  .default(handleDefault);

export default reducer;
